import { Button, Tooltip, GlanceLoader } from '../ui-components';
import React from 'react';

function PresenceState({onEnterKey, onMCS, onJoin, gicon, showMCS=true, showEnterKey=true, languageManager}) {

  return (
    <>
      <div className="SizeWrapper">
        <div className="rowAlign">
          { gicon && <GlanceLoader size="12" spinning={false}></GlanceLoader> }
          { showEnterKey && <span className="wrapper">
            <Tooltip text={languageManager.getPhrase("integration-instant-connect","Instant connect")} offset={8} size="small">
            <Button
              className="PresenceLayout"
              size="small"
              variant="warning"
              shape="rounded-full"
              animation={true}
              onClick={() => (typeof(onJoin) === typeof(Function)) ? onJoin() : console.log('Presence pressed')}
            >
              {languageManager.getPhrase("integration-join","Join")}
            </Button>
            </Tooltip>
            <Tooltip text={languageManager.getPhrase("integration-enter-customer-key","Enter customer’s key")} offset={8} size="small">
            <Button
              size="small"
              variant="secondary"
              shape="rounded-full"
              animation={false}
              onClick={() => (typeof(onEnterKey) === typeof(Function)) ? onEnterKey() : console.log('Have key pressed')}
            >
              {languageManager.getPhrase("integration-have-key","Have key?")}
            </Button>
            </Tooltip>
          </span> }

          { showMCS && <span className="wrapper">
            <Tooltip text={languageManager.getPhrase("integration-send-link-to-phone","Send link to customer’s phone")} offset={8} size="small"> 
            <Button
              size="small"
              variant="tertiary"
              shape="rounded-full"
              animation={false}
              onClick={() => (typeof(onMCS) === typeof(Function)) ? onMCS() : console.log('MCS pressed')}
            >
              {languageManager.getPhrase("integration-camera-share","Camera Share")}
            </Button>
            </Tooltip>
          </span> }
        </div>
      </div>
    </>
  );
}

export default PresenceState;
